import React from 'react'
import last from 'lodash/last'
import { Panel } from '@elements'

export const MultipleContentSection = ({
  multipleContentSection,
  marginBottom,
  marginTop,
}) => {
  const pb =
    marginBottom === `40`
      ? `pb-40`
      : marginBottom === `32`
      ? `pb-32`
      : marginBottom === `24`
      ? `pb-24`
      : `pb-0`
  const pt =
    marginTop === `40`
      ? `pt-40`
      : marginTop === `32`
      ? `pt-32`
      : marginTop === `24`
      ? `pt-24`
      : `pt-0`
  return (
    <Panel className={`${pb} ${pt}`}>
      {multipleContentSection.map((section, idx) => {
        // Log out data for development
        process.env.NODE_ENV !== `production` &&
          console.log('MultipleContentSection -> section', section)

        // Assign moduleName to the fieldGroupName field
        const moduleName = section && last(section.fieldGroupName.split('_'))

        // Run through list of modules and render children based on their moduleName, assigned above
        // Spreading props into module for consumption by component
        switch (moduleName) {
          case 'ImageList':
            const { ImageList } = require('./ImageList/ImageList')
            return <ImageList key={idx} {...section} />
          case 'PeopleList':
            const { PeopleList } = require('./PeopleList/PeopleList')
            return <PeopleList key={idx} {...section} />
          case 'WhatsNews':
            const { WhatsNews } = require('./WhatsNews/WhatsNews')
            return <WhatsNews key={idx} {...section} />
          case 'Wysiwyg':
            const { WYSIWYG } = require('./WYSIWYG/WYSIWYG')
            return <WYSIWYG key={idx} {...section} />
          default:
            return (
              <div key={idx}>
                <span role="img" aria-label="Construction sign">
                  🚧
                </span>
                Module {moduleName} is still under construction{' '}
                <span role="img" aria-label="Construction sign">
                  🚧
                </span>
              </div>
            )
        }
      })}
    </Panel>
  )
}
